import React, { useState } from "react";
import { getImageUrl, getNameOnAvatar, replaceSpaceWithHyphen } from "../../../utility/utility";
import DocumentUploader from "../../common/document-uploader/document-uploader";
import { Event_Type } from "../../../constant/constant";
import { getEventById, updateEvent } from "../action/events.actions";
import '../../../styles/component/user/eventCoverImage.scss'
import { Tooltip } from "antd";

interface EventCoverProps {
    event: any;
    className?: string;
    isAdmin:boolean;
}


const EventCoverImage: React.FC<EventCoverProps> = ({event, className,isAdmin}) => {
    const [coverImg, setCoverImg] = useState(event.coverImage);
    const eventType = replaceSpaceWithHyphen(Event_Type[event.eventType as keyof typeof Event_Type]).toLowerCase();
    const isEvent =
        event.eventType === "CUSTOM_EVENT" ||
        event.eventType === "TRAINING";


    function mapEventToPayload(value: any) {
        switch (value.eventType) {
            case 'BIRTHDAY':
                return {
                    id: value.id,
                    employeeId: value.employeeId,
                    name: value.name,
                    designation: value.designation,
                    dateOfBirth: value.dateOfBirth,
                    startDate: value.startDate,
                    endDate: value.endDate,
                    photoCount: value.photoCount,
                    eventType: value.eventType,
                };
            case 'WORK_ANNIVERSARY':
                return {
                    id: value.id,
                    employeeId: value.employeeId,
                    name: value.name,
                    designation: value.designation,
                    dateOfJoining: value.dateOfJoining,
                    startDate: value.startDate,
                    endDate: value.endDate,
                    yearsCompleted: value.yearsCompleted,
                    photoCount: value.photoCount,
                    eventType: value.eventType,
                }
            case 'CUSTOM_EVENT':
            case 'TRAINING':
                return {
                    id: value.id,
                    name: value.name,
                    startDate: value.startDate,
                    endDate: value.endDate,
                    startTime: value.startTime,
                    endTime: value.endTime,
                    venue: value.venue,
                    hostBy: value.hostBy,
                    active: value.active,
                    description: value.description,
                    eventType: value.eventType,
                    photoCount: value.photoCount,
                    eventStatus: value.eventStatus
                }
        }

    }

    async function updateEventCoverImage(doc: any) {
        const res = await getEventById(event.id);
        const data = mapEventToPayload(res)
        const payload = {...data, coverImageId: doc.id};
        await updateEvent(event.id, payload);
        setCoverImg(doc);
    }

    return (
        <>
            {!coverImg ? (
                <div className={`event-card__cover ${eventType} ${className}`}>
                    {!isEvent ?
                        (
                            <>
                                <div className="confetti confetti--1"/>
                                <div className="confetti confetti--2"/>
                                <div className="confetti confetti--3"/>
                                <div className="confetti confetti--4"/>

                                <div className="cover-center">
                                    <div className="initials-circle">
                                        {event.profilePhoto ?
                                            (<img
                                                src={getImageUrl(event.profilePhoto, 'small')}
                                                alt="event-cover"
                                                className={'profile-photo'}
                                            />) :
                                            getNameOnAvatar(event.name)
                                        }
                                    </div>

                                    <div className="cover-badge">
                                        {event.eventType === "BIRTHDAY"
                                            ? "🎂 HAPPY BIRTHDAY"
                                            : "🏆 WORK ANNIVERSARY"}
                                    </div>

                                </div>

                                <div className="balloons">
                                    <span className="balloon balloon--1"/>
                                    <span className="balloon balloon--2"/>
                                    <span className="balloon balloon--3"/>
                                    <span className="balloon balloon--4"/>
                                    <span className="balloon balloon--5"/>
                                </div>
                                <Tooltip title={'upload cover image'}>
                                    <div className={'add-img-btn'}>

                                        {isAdmin && <DocumentUploader
                                            disabled={false}
                                            docType={'EVENT_PHOTO'}
                                            uploadMode="instant"
                                            uploadButtonText={''}
                                            onUploadSuccess={(doc) => {
                                                updateEventCoverImage(doc);
                                            }
                                            }
                                        />}

                                    </div>
                                </Tooltip>
                            </>
                        ) :

                        (
                            <Tooltip title={'upload cover image'}>
                                <div className={'add-img-btn'}>
                                    <DocumentUploader
                                        disabled={false}
                                        docType={'EVENT_PHOTO'}
                                        uploadMode="instant"
                                        uploadButtonText={''}
                                        onUploadSuccess={(doc) => {
                                            updateEventCoverImage(doc);
                                        }}
                                    />
                                </div>
                            </Tooltip>
                        )
                    }
                </div>
            ) : (
                <img
                    src={getImageUrl(coverImg, 'medium')}
                    alt="event-cover"
                    className={className}
                />
            )}
        </>
    );
};


export default EventCoverImage;
